









































































import { Component, Prop, Vue } from "vue-property-decorator";
import SuratRujukanEdukasiSvc from "@/services/SuratRujukanEdukasi";
import { getFormattedDateTime, getHumanDateTime } from "@/utility/DateUtils";

@Component
export default class RujukanEdukasiRiwayatModal extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ default: null }) surat: any;

  get dialog(): boolean {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

  get tatalaksana(): string[] {
    const list = this.surat?.edukasi_diharapkan;
    return Array.isArray(list) ? list.filter(item => !!item) : [];
  }

  formatTanggal(date) {
    return date ? getFormattedDateTime(date, "DD-MM-YYYY", "YYYY-MM-DD") : "-";
  }

  formatWaktu(date) {
    return getHumanDateTime(date);
  }

  cetak() {
    SuratRujukanEdukasiSvc.print(this.surat.id);
  }
}
